function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M334.237,336.517c-0.935-1.39-2.437-2.297-4.103-2.477h-0.76c-98.837,0.105-179.045-79.933-179.15-178.77 c-0.061-57.292,27.312-111.15,73.63-144.87c2.607-1.745,3.306-5.273,1.561-7.88c-1.062-1.587-2.851-2.534-4.761-2.52l0.04,0.04 C115.539,0.029,30.285,85.265,30.274,190.42c-0.011,105.155,85.225,190.409,190.38,190.42c40.26,0.004,79.485-12.753,112.04-36.44 C335.297,342.649,335.988,339.12,334.237,336.517z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M273.123,223.354c-0.679-0.577-1.483-0.985-2.349-1.194l-0.04-0.08l-15.36-3.68l-8.24-13.36 c-1.624-2.684-5.116-3.544-7.8-1.92c-0.786,0.475-1.445,1.134-1.92,1.92l-8.32,13.36l-15.12,3.68 c-3.081,0.59-5.1,3.566-4.51,6.647c0.186,0.973,0.624,1.881,1.27,2.633l10.24,12l-1.2,15.76c-0.279,3.125,2.027,5.884,5.152,6.163 c0.975,0.087,1.956-0.079,2.848-0.483l14.64-6l14.32,5.88c2.86,1.288,6.223,0.014,7.512-2.846 c0.383-0.851,0.551-1.783,0.488-2.714l-1.2-15.76l10.24-12C275.805,228.969,275.514,225.385,273.123,223.354z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M297.803,78.394c-0.679-0.577-1.483-0.985-2.349-1.194l0.08,0.2l-26.24-6.4l-14.16-22.92 c-1.624-2.684-5.116-3.544-7.8-1.92c-0.786,0.475-1.445,1.134-1.92,1.92l-14.2,23l-26,6.36c-3.064,0.674-5.001,3.704-4.327,6.768 c0.175,0.794,0.518,1.542,1.007,2.192l17.48,20.6l-2.04,26.96c-0.279,3.125,2.027,5.884,5.152,6.163 c0.975,0.087,1.956-0.079,2.848-0.483l25-10.24l24.68,10.12c2.86,1.288,6.223,0.014,7.512-2.846 c0.383-0.851,0.551-1.783,0.488-2.714l-2.04-26.96l17.48-20.6C300.485,84.009,300.194,80.425,297.803,78.394z"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M348.563,170.354c-0.679-0.577-1.483-0.985-2.349-1.194l-0.16-0.08l-12-2.88l-6.36-10.32 c-1.624-2.684-5.116-3.544-7.8-1.92c-0.786,0.475-1.445,1.134-1.92,1.92l-6.28,10.52l-11.6,2.84 c-3.075,0.619-5.067,3.613-4.448,6.689c0.182,0.907,0.583,1.755,1.168,2.471l8,9.32l-0.92,12 c-0.279,3.125,2.027,5.884,5.152,6.163c0.975,0.087,1.956-0.079,2.848-0.483l11.28-4.64l10.96,4.48 c2.86,1.288,6.223,0.014,7.512-2.846c0.383-0.851,0.551-1.783,0.488-2.714l-0.92-12l8-9.32 C351.245,175.969,350.954,172.385,348.563,170.354z"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 380.84 380.84",
    style: {
      enableBackground: "new 0 0 380.84 380.84"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.140c873a.svg";
export { ForwardRef as ReactComponent };